module.exports = __webpack_public_path__ + "img/thumbnail-7.42d55669.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-7.jpg
// module id = VhbN
// module chunks = 1